export const startJobMission = (id) => ({
  type: "START_JOB_MISSION",
  id
});



// WEBPACK FOOTER //
// ./src/store/actions/help/jobs.js